<template>
  <div class="container">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Gestión de Tipos de Turno</v-toolbar-title>
      </v-toolbar>

      <v-data-table
        v-if="listaTiposTurno.length"
        :headers="headers"
        :items="listaTiposTurno"
        class="elevation-1"
        locale="es-ar"
        item-key="idTiposTurno"
        :items-per-page="10"
        ref="myTable"
        :disable-sort="true"
        :footer-props="{
          itemsPerPageText: 'Filas por página',
        }"
      >
        <template v-slot:item.porDefecto="{ item }">
          <v-simple-checkbox
            v-model="item.porDefecto"
            disabled
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.disponibleWeb="{ item }">
          <v-simple-checkbox
            v-model="item.disponibleWeb"
            disabled
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.permiteMultiplesPacientes="{ item }">
          <v-simple-checkbox
            v-model="item.permiteMultiplesPacientes"
            disabled
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                color="purple"
                class="mr-3"
                v-on="on"
                v-bind="attrs"
                @click.stop="editarTipoTurno(item)"
                >mdi-pencil</v-icon
              >
            </template>
            <span>Editar Tipo de Turno</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                v-on="on"
                color="red"
                v-bind="attrs"
                @click="borrarTipoTurno(item)"
                >mdi-delete</v-icon
              >
            </template>
            <span>Eliminar Tipo de Turno</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-alert class="mt-4" color="purple" dark outlined v-else>
        No hay Tipos de Turno configurados para la institución.
      </v-alert>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click.stop="nuevoTipoTurno"
          >Nuevo Tipo de Turno</v-btn
        >
        <v-btn color="error" @click.stop="salir">Salir</v-btn>
      </v-card-actions>
      <NuevoTipoTurno
        :visible="showNuevoTipoTurno"
        :esPorDefecto="!listaTiposTurno.length"
        @close="cierraNuevoTipoTurno()"
        @tipoTurnoRegistrado="tipoTurnoRegistrado()"
      ></NuevoTipoTurno>
      <EditarTipoTurno
        :visible="showEditarTipoTurno"
        :idTipoTurno="editedItem.idTipoTurno"
        :esPorDefecto="listaTiposTurno.length === 1"
        @close="cierraEditarTipoTurno()"
        @tipoTurnoModificado="tipoTurnoModificado()"
      ></EditarTipoTurno>
    </v-card>
  </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>
<script>
import axios from "../../../axios-auth.js";
import router from "../../../router/index.js";
import NuevoTipoTurno from "./NuevoTipoTurno.vue";
import EditarTipoTurno from "./EditarTipoTurno.vue";
export default {
  data: (vm) => ({
    listaTiposTurno: [],
    headers: [
      { text: "Nombre", value: "nombreTipoTurno" },
      { text: "Sigla", value: "sigla" },
      { text: "Predeterminado", value: "porDefecto" },
      { text: "Disponible Web", value: "disponibleWeb" },
      { text: "Múlt. Pacientes", value: "permiteMultiplesPacientes" },
      { text: "Duración (Para Turnos Web)", value: "duracion" },
      { text: "Acciones", value: "actions" },
    ],
    showNuevoTipoTurno: false,
    showEditarTipoTurno: false,
    editedItem: {},
    editedIndex: -1,
  }),
  methods: {
    salir() {
      router.push({ path: "/Home" });
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 1500,
      });
    },

    borrarTipoTurno(item) {
      this.$swal({
        title: "Borrar Tipo de Turno",
        text: "¿Desea borrar el tipo de turno?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const idTipoTurno = item.idTipoTurno;
          let self = this;
          axios
            .get("/Profesional/BorrarTipoTurno?", {
              params: {
                idTipoTurno: idTipoTurno,
              },
            })
            .then((response) => {
              if (response.data == "error") {
                self.showAlert({
                  icon: "error",
                  title:
                    "Algun turno tiene asociado este tipo de turno. No se puede borrar.",
                  vm: self,
                });
              } else {
                self.showAlert({
                  icon: "success",
                  title: "Tipo de turno borrado exitosamente",
                  vm: self,
                });
                setTimeout(self.buscarTiposTurno(), 1700);
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "El tipo de turno no pudo ser borrado",
                vm: this,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    cierraNuevoTipoTurno() {
      this.showNuevoTipoTurno = false;
    },
    cierraEditarTipoTurno() {
      this.showEditarTipoTurno = false;
    },
    tipoTurnoRegistrado() {
      this.showNuevoTipoTurno = false;
      this.buscarTiposTurno();
    },
    tipoTurnoModificado() {
      this.showEditarTipoTurno = false;
      this.buscarTiposTurno();
    },
    nuevoTipoTurno() {
      this.showNuevoTipoTurno = true;
    },
    editarTipoTurno(item) {
      this.editedIndex = this.listaTiposTurno.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showEditarTipoTurno = true;
    },
    buscarTiposTurno() {
      const filtrosData = {
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };

      let self = this;
      axios
        .get("/Profesional/GetTiposTurno?", {
          params: {
            idInstitucion: filtrosData.idInstitucion,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.listaTiposTurno = response.data;
          else self.listaTiposTurno = [];
        })
        .catch(function (error) {});
    },
  },
  created() {
    this.buscarTiposTurno();
  },
  components: {
    NuevoTipoTurno,
    EditarTipoTurno,
  },
};
</script>
